import React from 'react';

import * as styles from './virtualized-card-list-loader.scss';

export const VirtualizedCardListLoader = () => {
  return (
    <div className={styles.skeletonList} data-testid="loader-spinner">
      <div className={styles.skeletonRow} />
      <div className={styles.skeletonRow} />
      <div className={styles.skeletonRow} />
    </div>
  );
};
